module.exports = __webpack_public_path__ + "static/media/snow-blowing.978797c2.svg";